module.exports = __webpack_public_path__ + "img/portrait-086.2f7211d7.jpg";